// Container for COLLECTION collection slides 
// Connect to redux, fetch appropriate slides 

import { connect } from 'react-redux'
import {
  fetchCollectionRows,
  clearCollectionRows
} from './actions'
import {
  getViewMode } from '../app/selectors'
import {
  getCollectionArtistSlug,
  getCollectionRows,
  getCollectionColours,
  getCollectionTitle,
  getCollectionSubtitle,
  getCollectionFetching,
  getCollectionRequestId
} from './selectors'
import Collection from './collection'

const mapStateToProps = state => {
  return {
    titleSlug: getCollectionArtistSlug(state),
    requestId: getCollectionRequestId(state),
    rows: getCollectionRows(state),
    title: getCollectionTitle(state),
    subtitle: getCollectionSubtitle(state),
    colours: getCollectionColours(state),
    fetching: getCollectionFetching(state),
    viewMode: getViewMode(state)
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onRequestRows: id => {
      dispatch(fetchCollectionRows(id))
    },
    onClearRows: () => {
      dispatch(clearCollectionRows())
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Collection)



// WEBPACK FOOTER //
// ./src/components/collection-container/index.js